(function () {
  var els = document.querySelectorAll('[data-kopero-illus]');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('kopero-illus--in'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('kopero-illus--in');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });
  els.forEach(function (e) { obs.observe(e); });
})();
